/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M682.33 190.65C578.659 82.117 426.045 56.066 298.866 112.482l229.07 239.816-185.282 193.967-229.071-239.814C59.699 439.596 84.578 599.368 188.25 707.904c115.107 120.511 290.554 139.345 424.526 56.515l188.665 197.506c46.823-36.713 88.45-80.296 123.519-129.312L736.305 635.106c79.13-140.257 61.144-323.941-53.975-444.458v.002z"/>'
  }
})
